var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResponsibilityApproved(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83523 1.28975C8.61555 1.07008 8.25938 1.07009 8.03977 1.28976C7.8201 1.50944 7.8201 1.8656 8.03977 2.08526L8.9547 3.00015C5.24762 3.02451 2.25 6.03719 2.25 9.75C2.25 13.478 5.27208 16.5 9 16.5C12.5206 16.5 15.4112 13.8051 15.7223 10.3652C15.7503 10.0558 15.5222 9.78225 15.2128 9.75428C14.9034 9.7263 14.6299 9.95445 14.6019 10.2638C14.3427 13.1294 11.9333 15.375 9 15.375C5.89339 15.375 3.375 12.8566 3.375 9.75C3.375 6.65867 5.8687 4.14977 8.95425 4.12518L8.03977 5.03966C7.8201 5.25933 7.8201 5.61549 8.03977 5.83516C8.25945 6.05483 8.61555 6.05483 8.83523 5.83516L10.7102 3.96016C10.8158 3.85466 10.875 3.71159 10.875 3.5624C10.875 3.41321 10.8158 3.27014 10.7102 3.16466L8.83523 1.28975ZM11.8378 7.66478C12.0575 7.88445 12.0575 8.24055 11.8378 8.46023L8.46023 11.8379C8.35477 11.9433 8.21168 12.0026 8.0625 12.0026C7.91332 12.0026 7.77023 11.9433 7.66477 11.8379L6.16475 10.3379C5.94509 10.1182 5.94509 9.762 6.16475 9.54233C6.38442 9.32265 6.74058 9.32265 6.96025 9.54233L8.0625 10.6446L11.0422 7.66478C11.2619 7.44509 11.6181 7.44508 11.8378 7.66478Z",
    fill: "#636363"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsibilityApproved);
export default __webpack_public_path__ + "static/media/responsibility_approved.89c85cf18eeea05b3ca6cddbc4e9399c.svg";
export { ForwardRef as ReactComponent };